import { TBusinessMetrics } from "./type";
import { ICapsuleData } from "@/pages/strategic/components/CapsuleBar/type.d";
import { IBusinessMetricCardConfig, IBusinessGrossRevenueOverview, IBusinessGrossRevenueCapsule } from '@/pages/strategic/pages/BusinessManagement/type.d';
import { buildUpdateTime, buildPeriod, buildFullYearPeriod, getYearPrefix, roundToDisplayPrecision } from '@sg/utils/common';
import Q1 from '@sg/assests/images/Q1.svg';
import Q2 from '@sg/assests/images/Q2.svg';
import Q3 from '@sg/assests/images/Q3.svg';
import Q4 from '@sg/assests/images/Q4.svg';

// Route Constants
// export const ROUTE_PORTFOLIO_OVERVIEW_BOARD_GOVERNANCE = '/g-pop/Studio/PortfolioOverview?filter=%7B%22tab%22%3A%22management_boardGovernance%22%7D';
// export const ROUTE_STUDIOS_BOARD_GOVERNANCE = '/g-pop/Studio/PortfolioOverview?filter={"tab":"management_boardGovernance"}';

// Board Governance Status Mapping
export const mapBoardGovernanceStatus = (status: number): string => {
  switch (status) {
    case 0:
      return 'Upcoming';
    case 1:
      return 'Completed';
    default:
      return '';
  }
};

const STUDIO_OVERVIEW_TOTAL_REVENUE_CAPSUAL = (apiData?: any): ICapsuleData[] => {
  const actual = roundToDisplayPrecision(apiData?.revenue?.actual);
  const forecast = roundToDisplayPrecision(apiData?.revenue?.forecast);
  const kpi = roundToDisplayPrecision(apiData?.revenue?.kpi);
  const yearPrefix = getYearPrefix(apiData?.revenue?.datatime);
  
  const rateActual = kpi !== 0 && kpi != null && actual !== null && actual !== undefined 
    ? Math.round((actual / kpi) * 100) 
    : undefined;
  const rateForecast = kpi !== 0 && kpi != null && forecast !== null && forecast !== undefined 
    ? Math.round((forecast / kpi) * 100) 
    : undefined;
  
  return [
    {
      title: `${yearPrefix}A`,
      localeTitleKey: `${yearPrefix}A`,
      value: actual,
      rate: rateActual,
      type: 'pillar',
      colorType: 'skyBlue',
      insideAlign: 'dynamic',
      isBold: true,
    },
    {
      title: `${yearPrefix}F`,
      localeTitleKey: `${yearPrefix}F`,
      value: forecast,
      rate: rateForecast,
      type: 'pillar',
      colorType: 'purple',
      insideAlign: 'dynamic',
      isBold: true,
    },
    {
      title: `${yearPrefix}B`,
      localeTitleKey: `${yearPrefix}B`,
      value: kpi,
      rate: 100,
      type: 'total',
      markWidth: 2,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title',
      isBold: true,
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    }
  ];
};

const STUDIO_OVERVIEW_TOTAL_PROFIT_CAPSUAL = (apiData?: any): ICapsuleData[] => {
  const yearPrefix = getYearPrefix(apiData?.profit?.datatime);
  
  return [
    {
      title: `${yearPrefix}A`,
      localeTitleKey:  `${yearPrefix}A`,
      value: roundToDisplayPrecision(apiData?.profit?.actual),
      type: 'pillar',
      displayTitleFormat: 'title,: ,$,formattedValue',
      insideAlign: 'dynamic', 
      colorType: 'skyBlue',
      isBold: true,
    },
    {
      title: `${yearPrefix}F`,
      localeTitleKey:  `${yearPrefix}F`,
      value: roundToDisplayPrecision(apiData?.profit?.forecast),
      type: 'pillar',
      displayTitleFormat: 'title,: ,$,formattedValue',
      insideAlign: 'dynamic', 
      colorType: 'purple',
      isBold: true,
    },
    {
      title: `${yearPrefix}B`,
      localeTitleKey:  `${yearPrefix}B`,
      value: roundToDisplayPrecision(apiData?.profit?.kpi),
      type: 'total',
      markWidth: 2,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title',
      isBold: true,
    },
    {
      title: '0',
      value: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    }
  ];
};

const STUDIO_STUDIOS_TOTAL_REVENUE_CAPSUAL = (apiData?: any): ICapsuleData[] => {
  const actualSource = apiData?.revenue?.actual;
  const forecastSource = apiData?.revenue?.forecast;
  const kpiSource = apiData?.revenue?.kpi;
  const yearPrefix = getYearPrefix(apiData?.revenue?.datatime);

  const actual = roundToDisplayPrecision(actualSource);
  const forecast = roundToDisplayPrecision(forecastSource);
  const kpi = roundToDisplayPrecision(kpiSource);
  
  const rateActual = kpi !== 0 && kpi != null && actual !== null && actual !== undefined 
    ? Math.round((actual / kpi) * 100) 
    : undefined;
  const rateForecast = kpi !== 0 && kpi != null && forecast !== null && forecast !== undefined 
    ? Math.round((forecast / kpi) * 100) 
    : undefined;
  
  return [
    {
      title: `${yearPrefix}A`,
      localeTitleKey: `${yearPrefix}A`,
      value: actual,
      rate: rateActual,
      type: 'pillar',
      insideAlign: 'dynamic', 
      colorType: 'skyBlue',
      isBold: true,
    },
    {
      title: `${yearPrefix}F`,
      localeTitleKey: `${yearPrefix}F`,
      value: forecast,
      rate: rateForecast,
      type: 'pillar',
      insideAlign: 'dynamic', 
      colorType: 'purple',
      isBold: true,
    },
    {
      title: `${yearPrefix}B`,
      localeTitleKey: `${yearPrefix}B`,
      value: kpi,
      rate: 100,
      type: 'total',
      markWidth: 2,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title',
      isBold: true,
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    }
  ];
};

const STUDIO_STUDIOS_TOTAL_PROFIT_CAPSUAL = (apiData?: any): ICapsuleData[] => {
  const yearPrefix = getYearPrefix(apiData?.profit?.datatime);
  
  return [
    {
      title: `${yearPrefix}A`,
      localeTitleKey: `${yearPrefix}A`,
      value: roundToDisplayPrecision(apiData?.profit?.actual),
      type: 'pillar',
      displayTitleFormat: 'title,: ,$,formattedValue',
      insideAlign: 'dynamic',  
      colorType: 'skyBlue',
      isBold: true,
    },
    {
      title: `${yearPrefix}F`,
      localeTitleKey: `${yearPrefix}F`,
      value: roundToDisplayPrecision(apiData?.profit?.forecast),
      type: 'pillar',
      displayTitleFormat: 'title,: ,$,formattedValue',
      insideAlign: 'dynamic',  
      colorType: 'purple',
      isBold: true,
    },
    {
      title: `${yearPrefix}B`,
      localeTitleKey: `${yearPrefix}B`,
      value: roundToDisplayPrecision(apiData?.profit?.kpi),
      type: 'total',
      markWidth: 2,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title',
      isBold: true,
    },
    {
      title: '0',
      value: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    }
  ];
};

const STUDIO_IN_DEV_PROJECT_TOTAL_SPEND_CAPSUAL = (apiData?: any): ICapsuleData[] => {
  const spendValue = apiData?.total_spent?.spend_to_date;
  const estimatedValue = apiData?.total_spent?.estimated_dev_cost;
  const approvedValue = apiData?.total_spent?.approved_dev_cost;
  
  // Calculate rates based on approved budget as 100%
  const rateSpend = approvedValue !== 0 && approvedValue != null && spendValue !== null && spendValue !== undefined 
    ? Math.round((spendValue / approvedValue) * 100) 
    : undefined;
  const rateEstimated = approvedValue !== 0 && approvedValue != null && estimatedValue !== null && estimatedValue !== undefined 
    ? Math.round((estimatedValue / approvedValue) * 100) 
    : undefined;
  
  return [
    { 
      // title: '25A', 
      title: 'Spend to Date', 
      // localeTitleKey: 'dbs_ytm_actual_short', 
      localeTitleKey: 'dbs_spend_to_date', 
      value: roundToDisplayPrecision(spendValue), 
      rate: rateSpend, 
      type: 'pillar', 
      colorType: 'skyBlue', 
      isBold: true, 
      insideAlign: 'dynamic',  
      // titlePosition: 'custom', 
      // left: '4%' 
    },
    { 
      title: '25F', 
      localeTitleKey: 'dbs_budget_to_next_milestone', 
      value: roundToDisplayPrecision(estimatedValue), 
      rate: rateEstimated, 
      type: 'pillar', 
      colorType: 'purple', 
      isBold: true, 
      insideAlign: 'dynamic',  
      // titlePosition: 'outside' 
    },
    { 
      title: '25B', 
      localeTitleKey: 'dbs_overall_budget', 
      value: roundToDisplayPrecision(approvedValue), 
      rate: 100, 
      type: 'total', 
      markWidth: 2, 
      titlePosition: 'top', 
      colorType: 'orange', 
      titleField: 'title', 
      markHeight: 40, 
      displayTitleFormat: 'title', 
      isBold: true,
      preventMarkOverflow: true,
    },
    { 
      title: '0', 
      value: 0, 
      rate: 0, 
      type: 'zero', 
      markWidth: 2, 
      isBold: true, 
      titlePosition: 'bottom', 
      titleField: 'value', 
      markHeight: 40, 
      displayTitleFormat: 'formattedValue', 
      colorType: 'black' 
    }
  ];
};

// const toNumericValue = (value: any): number | null => {
//   if (value === null || value === undefined) {
//     return null;
//   }
//   if (typeof value === 'string') {
//     const trimmed = value.trim();
//     if (!trimmed) {
//       return null;
//     }
//     const parsed = Number(trimmed);
//     return Number.isFinite(parsed) ? parsed : null;
//   }
//   if (typeof value === 'number') {
//     return Number.isFinite(value) ? value : null;
//   }
//   const parsed = Number(value);
//   return Number.isFinite(parsed) ? parsed : null;
// };

const STUDIO_IN_DEV_PROJECT_HEADCOUNT_CAPSUAL = (apiData?: any): ICapsuleData[] => {
  const actualValue = apiData?.headcount?.actual_headcount;
  const currentValue = apiData?.headcount?.current_headcount;
  const nextValue = apiData?.headcount?.next_headcount;
  
  // Calculate rates based on next milestone as 100%
  const rateActual = nextValue !== 0 && nextValue != null && actualValue !== null && actualValue !== undefined 
    ? Math.round((actualValue / nextValue) * 100) 
    : undefined;
  const rateCurrent = nextValue !== 0 && nextValue != null && currentValue !== null && currentValue !== undefined 
    ? Math.round((currentValue / nextValue) * 100) 
    : undefined;
  
  return [
    { 
      title: '25A', 
      localeTitleKey: 'dbs_actual', 
      value: actualValue, 
      rate: rateActual, 
      type: 'pillar', 
      displayTitleFormat: 'title,: ,formattedValue, (,rate,%,)', 
      colorType: 'skyBlue', 
      isBold: true, 
      insideAlign: 'dynamic',
    },
    { 
      title: '25F', 
      localeTitleKey: 'dbs_planned_current_milestone', 
      value: currentValue, 
      rate: rateCurrent, 
      type: 'pillar', 
      displayTitleFormat: 'title,: ,formattedValue, (,rate,%,)', 
      colorType: 'purple', 
      isBold: true, 
      insideAlign: 'dynamic',
    },
    { 
      title: '25B', 
      localeTitleKey: 'dbs_planned_next_milestone', 
      value: nextValue, 
      type: 'total', 
      markWidth: 2, 
      titlePosition: 'top', 
      colorType: 'orange', 
      titleField: 'title', 
      markHeight: 40, 
      displayTitleFormat: 'title', 
      isBold: true ,
      preventMarkOverflow: true,
    },
    { 
      title: '0', 
      value: 0, 
      type: 'zero', 
      markWidth: 2, 
      isBold: true, 
      titlePosition: 'bottom', 
      titleField: 'value', 
      markHeight: 40, 
      displayTitleFormat: 'formattedValue', 
      colorType: 'black' 
    }
  ];
};

export const STUDIO_OVERVIEW_TOTAL_REVENUE = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: STUDIO_OVERVIEW_TOTAL_REVENUE_CAPSUAL(apiData),
  directionType: 'normal',
}];

export const STUDIO_OVERVIEW_TOTAL_PROFIT = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: STUDIO_OVERVIEW_TOTAL_PROFIT_CAPSUAL(apiData),
  directionType: 'centerInSameDirection',
}];

export const STUDIO_STUDIOS_TOTAL_REVENUE = (apiData?: any): IBusinessGrossRevenueCapsule[] => {
  // Check if any revenue values are negative to determine directionType
  const hasNegativeRevenue = apiData?.revenue && (
    apiData.revenue.actual < 0 || 
    apiData.revenue.forecast < 0 || 
    apiData.revenue.kpi < 0
  );
  
  return [{
    title: '',
    metrics: STUDIO_STUDIOS_TOTAL_REVENUE_CAPSUAL(apiData),
    directionType: hasNegativeRevenue ? 'centerInSameDirection' : 'normal',
  }];
};

export const STUDIO_STUDIOS_TOTAL_PROFIT = (apiData?: any): IBusinessGrossRevenueCapsule[] => {
  // Check if any profit values are negative to determine directionType
  const hasNegativeProfit = apiData?.profit && (
    apiData.profit.actual < 0 || 
    apiData.profit.forecast < 0 || 
    apiData.profit.kpi < 0
  );
  
  return [{
    title: '',
    metrics: STUDIO_STUDIOS_TOTAL_PROFIT_CAPSUAL(apiData),
    directionType: hasNegativeProfit ? 'centerInSameDirection' : 'normal',
  }];
};

export const STUDIO_IN_DEV_PROJECT_TOTAL_SPEND = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: STUDIO_IN_DEV_PROJECT_TOTAL_SPEND_CAPSUAL(apiData),
  directionType: 'normal',
}];

export const STUDIO_IN_DEV_PROJECT_HEADCOUNT = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: STUDIO_IN_DEV_PROJECT_HEADCOUNT_CAPSUAL(apiData),
  directionType: 'normal',
}];

export const STUDIO_OVERVIEW_TOTAL_REVENUE_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const yearPrefix = getYearPrefix(apiData?.revenue?.datatime);
  
  return [{
    // title: 'dbs_ytm_actual',
    title: `YTM Actual (${yearPrefix}A)`,
    key: '25A',
    value: apiData?.revenue?.actual,
    ratioUnit: 'MoM',
    ratioValue: apiData?.revenue?.mom?.toString(),
    definition: 'dbs_ytm_acutal_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_finance',
    colorType: 'skyBlue',
    period: buildPeriod(apiData?.revenue?.date)
  }, {
    // title: 'dbs_full_year_forecast',
    title: `Full Year Forecast (${yearPrefix}F)`,
    key: '25F',
    value: apiData?.revenue?.forecast,
    definition: 'dbs_full_year_forecast_definition',
    updateTime: 'dbs_update_time_need',
    source: 'dbs_update_source_finance',
    colorType: 'purple',
    period: buildFullYearPeriod(apiData?.revenue?.date)
  }, {
    // title: 'dbs_full_year_kpi',
    title: `Full Year KPI (${yearPrefix}B)`,
    key: '25B',
    value: apiData?.revenue?.kpi,
    definition: 'dbs_full_year_kpi_definition_l2',
    updateTime: 'dbs_update_time_year',
    source: 'dbs_update_source_finance',
    colorType: 'orange',
    period: buildFullYearPeriod(apiData?.revenue?.date)
  }];
};

export const STUDIO_OVERVIEW_TOTAL_PROFIT_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const yearPrefix = getYearPrefix(apiData?.profit?.datatime);
  
  return [{
    // title: 'dbs_ytm_actual',
    title: `YTM Actual (${yearPrefix}A)`,
    key: '25A',
    value: apiData?.profit?.actual,
    ratioUnit: 'MoM',
    ratioValue: apiData?.profit?.mom?.toString(),
    definition: 'dbs_ytm_acutal_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_finance',
    colorType: 'skyBlue',
    period: buildPeriod(apiData?.profit?.date)
  }, {
    // title: 'dbs_full_year_forecast',
    title: `Full Year Forecast (${yearPrefix}F)`,
    key: '25F',
    value: apiData?.profit?.forecast,
    definition: 'dbs_full_year_forecast_definition',
    updateTime: 'dbs_update_time_need',
    source: 'dbs_update_source_finance',
    colorType: 'purple',
    period: buildFullYearPeriod(apiData?.profit?.date)
  }, {
    // title: 'dbs_full_year_kpi',
    title: `Full Year KPI (${yearPrefix}B)`,
    key: '25B',
    value: apiData?.profit?.kpi,
    definition: 'dbs_full_year_kpi_definition_l2',
    updateTime: 'dbs_update_time_year',
    source: 'dbs_update_source_finance',
    colorType: 'orange',
    period: buildFullYearPeriod(apiData?.profit?.date)
  }];
};

export const STUDIO_STUDIOS_TOTAL_REVENUE_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const yearPrefix = getYearPrefix(apiData?.revenue?.datatime);
  
  return [{
    // title: 'dbs_ytm_actual',
    title: `YTM Actual (${yearPrefix}A)`,
    key: '25A',
    value: apiData?.revenue?.actual,
    ratioUnit: 'MoM',
    ratioValue: apiData?.revenue?.mom?.toString() || '0',
    definition: 'dbs_ytm_acutal_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_finance',
    colorType: 'skyBlue',
    period: buildPeriod(apiData?.revenue?.date)
  }, {
    // title: 'dbs_full_year_forecast',
    title: `Full Year Forecast (${yearPrefix}F)`,
    key: '25F',
    value: apiData?.revenue?.forecast,
    definition: 'dbs_full_year_forecast_definition',
    updateTime: 'dbs_update_time_need',
    source: 'dbs_update_source_finance',
    colorType: 'purple',
    period: buildFullYearPeriod(apiData?.revenue?.date)
  }, {
    // title: 'dbs_full_year_kpi',
    title: `Full Year KPI (${yearPrefix}B)`,
    key: '25B',
    value: apiData?.revenue?.kpi,
    definition: 'dbs_full_year_kpi_definition_l2',
    updateTime: 'dbs_update_time_year',
    source: 'dbs_update_source_finance',
    colorType: 'orange',
    period: buildFullYearPeriod(apiData?.revenue?.date)
  }];
};

export const STUDIO_STUDIOS_TOTAL_PROFIT_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const yearPrefix = getYearPrefix(apiData?.profit?.datatime);
  
  return [{
    // title: 'dbs_ytm_actual',
    title: `YTM Actual (${yearPrefix}A)`,
    key: '25A',
    value: apiData?.profit?.actual,
    ratioUnit: 'MoM',
    ratioValue: apiData?.profit?.mom?.toString() || '0',
    definition: 'dbs_ytm_acutal_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_finance',
    colorType: 'skyBlue',
    period: buildPeriod(apiData?.profit?.date)
  }, {
    // title: 'dbs_full_year_forecast',
    title: `Full Year Forecast (${yearPrefix}F)`,
    key: '25F',
    value: apiData?.profit?.forecast,
    definition: 'dbs_full_year_forecast_definition',
    updateTime: 'dbs_update_time_need',
    source: 'dbs_update_source_finance',
    colorType: 'purple',
    period: buildFullYearPeriod(apiData?.profit?.date)
  }, {
    // title: 'dbs_full_year_kpi',
    title: `Full Year KPI (${yearPrefix}B)`,
    key: '25B',
    value: apiData?.profit?.kpi,
    definition: 'dbs_full_year_kpi_definition_l2',
    updateTime: 'dbs_update_time_year',
    source: 'dbs_update_source_finance',
    colorType: 'orange',
    period: buildFullYearPeriod(apiData?.profit?.date)
  }];
};

export const STUDIO_IN_DEV_PROJECT_TOTAL_SPEND_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => [{
  title: 'dbs_spend_to_date',
  key: '25A',
  value: apiData?.total_spent?.spend_to_date,
  ratioUnit: 'MoM',
  ratioValue: apiData?.total_spent?.mom?.toString(),
  definition: 'dbs_spend_to_date_definition',
  updateTime: 'dbs_update_time_month',
  source: 'dbs_update_source_finance',
  colorType: 'skyBlue',
  period: buildPeriod(apiData?.total_spent?.end_date, apiData?.total_spent?.start_date)
  // period: buildPeriod(apiData?.total_spent?.std_end_date, apiData?.total_spent?.std_start_date)
}, {
  title: 'dbs_budget_to_next_milestone',
  key: 'Budget to next milestone',
  value: apiData?.total_spent?.estimated_dev_cost,
  definition: 'dbs_studio_in_dev_project_budget_to_next_milestone_definition',
  updateTime: 'dbs_update_time_as_need',
  source: 'dbs_update_source_finance',
  colorType: 'purple',
  period: buildPeriod(
    apiData?.total_spent?.estimated_dev_cost_end_date,
    apiData?.total_spent?.estimated_dev_cost_start_date,
  )
}, {
  title: 'dbs_overall_budget',
  key: 'Overall Budget',
  value: apiData?.total_spent?.approved_dev_cost,
  definition: 'dbs_studio_in_dev_project_overall_budget_definition',
  updateTime: 'dbs_update_time_as_need',
  source: 'dbs_update_source_finance',
  colorType: 'orange',
  period: buildPeriod(
    apiData?.total_spent?.approved_dev_cost_end_date,
    apiData?.total_spent?.approved_dev_cost_start_date,
  )
}];

export const STUDIO_IN_DEV_PROJECT_HEADCOUNT_METRICS = (apiData?: any): IBusinessGrossRevenueOverview[] => [{
  title: 'dbs_actual',
  key: 'Actual',
  value: apiData?.headcount?.actual_headcount,
  unit: '',
  ratioUnit: 'MoM',
  ratioValue: apiData?.headcount?.mom?.toString(),
  definition: 'dbs_studio_in_dev_project_actual_definition',
  updateTime: 'dbs_update_time_month',
  source: 'dbs_update_source_pmi',
  colorType: 'skyBlue',
  period: apiData?.headcount?.date
}, {
  title: 'dbs_planned_current_milestone',
  key: 'Planned - current milestone',
  value: apiData?.headcount?.current_headcount,
  unit: '',
  definition: 'dbs_studio_in_dev_project_planned_current_milestone_definition',
  updateTime: 'dbs_update_time_month',
  source: 'dbs_update_source_finance',
  colorType: 'purple',
  period: apiData?.headcount?.current_milestone
}, {
  title: 'dbs_planned_next_milestone',
  key: 'Planned - next milestone',
  value: apiData?.headcount?.next_headcount,
  unit: '',
  definition: 'dbs_studio_in_dev_project_planned_next_milestone_definition',
  updateTime: 'dbs_update_time_need',
  source: 'dbs_update_source_finance',
  colorType: 'orange',
  period: apiData?.headcount?.next_milestone
}];

export const REVENUE_TREND_TABLE_VS: ICapsuleData[] = [
  { title: 'vs1', value: 0, rate: 0, type: 'pillar', displayTitleFormat: 'formattedValue', colorType: 'red', titlePosition: 'outside' },
  { title: 'vs2', value: 0, rate: 0, type: 'pillar', displayTitleFormat: 'formattedValue', colorType: 'red', isHide: true, titlePosition: 'outside' },
  { title: 'vs3', value: 0, rate: 0, type: 'total', displayTitleFormat: 'formattedValue', colorType: 'red', isHide: true },
  { title: '', value: 0, rate: 0, type: 'zero', markWidth: 1, markHeight: 20, displayTitleFormat: 'none', colorType: 'gray', }
];

export const TABLE_VS_FIELD = ['25F', '25B'];
export const COEFFICIENT = 1.1;

export const defaultQS = [
  {
    title: 'Q1',
    icon: Q1,
    data: [],
  },
  {
    title: 'Q2',
    icon: Q2,
    data: [],
  },
  {
    title: 'Q3',
    icon: Q3,
    data: [],
  },
  {
    title: 'Q4',
    icon: Q4,
    data: [],
  },
];


export const STUDIO_OVERVIEW_TOTAL_REVENUE_CARD = (apiData?: any): IBusinessMetricCardConfig => ({
  title: 'dbs_total_revenue_studio',
  subTitle: buildUpdateTime(apiData?.revenue?.datatime),
  cards: STUDIO_OVERVIEW_TOTAL_REVENUE_METRICS(apiData),
  capsule: STUDIO_OVERVIEW_TOTAL_REVENUE(apiData)
});

export const STUDIO_OVERVIEW_TOTAL_PROFIT_CARD = (apiData?: any): IBusinessMetricCardConfig => ({
  title: 'dbs_total_profit_studio',
  subTitle: buildUpdateTime(apiData?.profit?.datatime),
  cards: STUDIO_OVERVIEW_TOTAL_PROFIT_METRICS(apiData),
  capsule: STUDIO_OVERVIEW_TOTAL_PROFIT(apiData)
});

export const STUDIO_STUDIOS_TOTAL_REVENUE_CARD = (apiData?: any): IBusinessMetricCardConfig => ({
  title: 'dbs_total_revenue',
  titleVariable: '',
  subTitle: buildUpdateTime(apiData?.revenue?.datatime),
  cards: STUDIO_STUDIOS_TOTAL_REVENUE_METRICS(apiData),
  capsule: STUDIO_STUDIOS_TOTAL_REVENUE(apiData)
});

export const STUDIO_STUDIOS_TOTAL_PROFIT_CARD = (apiData?: any): IBusinessMetricCardConfig => ({
  title: 'dbs_total_profit',
  titleVariable: '',
  subTitle: buildUpdateTime(apiData?.profit?.datatime),
  cards: STUDIO_STUDIOS_TOTAL_PROFIT_METRICS(apiData),
  capsule: STUDIO_STUDIOS_TOTAL_PROFIT(apiData)
});

export const STUDIO_IN_DEV_PROJECT_TOTAL_SPEND_CARD = (apiData?: any): IBusinessMetricCardConfig => ({
  title: 'dbs_total_spend',
  titleVariable: '',
  subTitle: buildUpdateTime(apiData?.total_spent?.datatime),
  cards: STUDIO_IN_DEV_PROJECT_TOTAL_SPEND_METRICS(apiData),
  capsule: STUDIO_IN_DEV_PROJECT_TOTAL_SPEND(apiData)
});

export const STUDIO_IN_DEV_PROJECT_HEADCOUNT_CARD = (apiData?: any): IBusinessMetricCardConfig => ({
  title: 'dbs_headcount',
  titleVariable: '',
  titleUnit: '',
  subTitle: buildUpdateTime(apiData?.headcount?.datatime),
  cards: STUDIO_IN_DEV_PROJECT_HEADCOUNT_METRICS(apiData),
  capsule: STUDIO_IN_DEV_PROJECT_HEADCOUNT(apiData)
});
